module.exports = __webpack_public_path__ + "static/media/ontario.67c6c1d7.png";